import "./Home.module.css";
import Hauptnavigation from "@/reusable_sections/Header";
import DesignDasKonvertiert from "./sections/DesignDasKonvertiert";
import TrapgardenQualityPromise from "./sections/TrapgardenQualityPromise";
import UnsereKernkompetenzen from "./sections/UnsereKernkompetenzen";
import AnalyseTrifftDesign from "./sections/AnalyseTrifftDesign";
import YourNextStep from "./sections/YourNextStep";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Hauptnavigation />
      <DesignDasKonvertiert />
      <TrapgardenQualityPromise />
      <UnsereKernkompetenzen />
      <AnalyseTrifftDesign />
      <YourNextStep />
      <Footer />
    </div>;
}